import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter } from '@angular/core';
import { Product } from '../product.model';
import { ProductService } from '../product.service';
import { Observable, concat, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import {  MatDialog } from '@angular/material/dialog';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { ProductEditPopup } from '../product-edit-popup/product-edit-popup';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';

@Component({
  selector: 'app-list-product',
  templateUrl: './list-product.component.html',
  styleUrls: ['./list-product.component.css']
})
export class ListProductComponent implements OnInit, OnDestroy {
  products$ = new Observable()//: Product[]
  filter = new UntypedFormControl('');
  filter$ = new Observable();
  filteredStates$ = new Observable()
  filterString = "";
  timer;
  addMoreClass;
  searchResultReceived = false;
  filteredStatesSub = new Subscription();

  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];

  updateProduct: EventEmitter<ActionButtonEvent>;
  onupdateProductSubscription: Subscription;

  deleteProduct: EventEmitter<ActionButtonEvent>;
  ondeleteProductSubscription: Subscription;

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Name',
    },
    {
      columnId: 'categories',
      name: 'Categories',
      hideOnMobile: true
    },{
      name: '#',
      columnId: 'productNumber',
      hideOnMobile: true
    },  {
      columnId: 'price',
      name: 'Price',
      hideOnMobile: true
    },{
      columnId: 'pant',
      name: 'Pant',
      hideOnMobile: true
    },
    {
      columnId: 'maxLimit',
      name: 'Max',
      hideOnMobile: true
    },
    {
      columnId: 'threshold',
      name: 'Threshold',
      hideOnMobile: true,
      isNumber: true
    },
    {
      columnId: 'cost',
      name: 'Cost',
      hideOnMobile: true
    }, {
      columnId: 'isNew',
      name: 'New',
      hideOnMobile: true
    }, {
      columnId: 'isHalal',
      name: 'Halal',
      hideOnMobile: true
    }, {
      columnId: 'dagensProdukt',
      name: 'Dagen Produkt',
      hideOnMobile: true
    }, {
      columnId: 'isNewRecipe',
      name: 'New Recipe',
      hideOnMobile: true
    }, {
      columnId: 'vat',
      name: 'Vat%',
      hideOnMobile: true
    }
  ]

  constructor(private productService: ProductService, private dialog: MatDialog) {
    this.addMoreClass= localStorage.getItem('currentView');
    this.updateProduct = new EventEmitter<ActionButtonEvent>();
    this.deleteProduct = new EventEmitter<ActionButtonEvent>();

    this.products$ = this.productService.data.pipe(
      map((products : any) => {
          return products.map((product: Product) => {
            return {
              ...product,
              categories: product.categories ? product.categories.join(', ') : '',
              // The edit form saves threshold from a text input, so some are
              // strings; coerce so the column sorts numerically.
              threshold: `${product.threshold ?? ''}`.trim() !== '' && !isNaN(Number(product.threshold)) ? Number(product.threshold) : product.threshold,
              rowClass: product.isDisabled ? 'disabled-product-row' : ''
            }
          });

        })
    );
  }

  ngOnInit() {
    this.productService.getProducts();


    this.rowActionButtons = [
      { icon: 'edit', tooltip: 'Edit Product', eventEmitter: this.updateProduct },
      { icon: 'clear', tooltip: 'Delete Product', eventEmitter: this.deleteProduct },
    ]


    this.onupdateProductSubscription = this.updateProduct.subscribe(event => {
      console.log("event", event)
      this.onUpdateProduct(event.eventData)
      });


    this.ondeleteProductSubscription = this.deleteProduct.subscribe(event => {
      console.log("event", event)
      this.onDeleteProduct(event.eventData)
      });


      this.products$.subscribe(console.log)
    // this.filter$ = this.filter.valueChanges.pipe(startWith(''));

    // this.filteredStates$ = combineLatest(this.products$, this.filter$).pipe(
    //   map(([products, filterString]) => (products as any).filter(product => {
    //     if (this.filterString != filterString) {
    //       this.searchResultReceived = false;
    //     }
    //     this.filterString = filterString as string;

    //     // return false
    //     if (!product.searchString)
    //       product.searchString = product.name.toLowerCase();
    //     if (!product.productNumberLowerCase)
    //       product.productNumberLowerCase = product.productNumber.toLowerCase()
    //     return (product.searchString.toLowerCase().indexOf((filterString as string).toLowerCase()) !== -1) ||
    //       (product.productNumberLowerCase.toLowerCase().indexOf((filterString as string).toLowerCase()) !== -1)
    //   })))

    // this.filteredStatesSub = this.filteredStates$.subscribe(data => {
    //   if (this.filterString.length > 2 && !this.searchResultReceived) {
    //     clearTimeout(this.timer);
    //     this.timer = setTimeout(() => {
    //       this.productService.getProductByNameAndPartNumber(this.filterString);
    //       // this.filterString = "";
    //       this.searchResultReceived = true;
    //       // this.filteredStatesSub.unsubscribe()
    //     }, 1000)
    //   }
    // })
  }



  addMore() {
    this.productService.getMoreProducts();
  }

  onUpdateProduct($event) {
    let pId = $event.uid;

    const dialogRef = this.dialog.open(ProductEditPopup, {
      disableClose: true,
      width: '750px', data: {
        pId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.updated) {
        this.productService.result = null;
        this.productService.getProducts();
      }
    });
  }

  onDeleteProduct($event) {
    let pId = $event.uid;
    let event = $event.$event;
    // event.stopPropagation();

    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? "
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.productService.deleteProduct(pId)
      }
    });

  }


  ngOnDestroy() {
    this.onupdateProductSubscription.unsubscribe();
  }
}
